/*
 *
 * DisputeEntryModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Apr-2026
*/

import DisputeEntryModal from './DisputeEntryModalContainer'

export default DisputeEntryModal
